import { Component, OnInit } from '@angular/core';
import { AdminNavigationComponent } from '../navigation/admin-navigation.component';
import { ErrorSummaryComponent } from '../../error-summary/error-summary.component';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { BackButtonComponent } from '../../ui';

@Component({
  selector: 'app-admin-layout',
  imports: [AdminNavigationComponent, ErrorSummaryComponent, RouterOutlet],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.css',
})
export class AdminLayoutComponent implements OnInit {
  backLinkPath: string | null = null;
  backLinkQueryParams: string | null = null;

  private role: string | null = sessionStorage.getItem('role');

  constructor(
    titleService: Title,
    private _route: ActivatedRoute,
    private _router: Router,
  ) {
    titleService.setTitle('Patient details | ' + this.role); // Set the title including the role
  }

  ngOnInit() {
    this.backLinkPath = sessionStorage.getItem('backLinkPath');
    this.backLinkQueryParams = sessionStorage.getItem('backLinkQueryParams');
  }

  goBack() {
    if (this.backLinkPath && this.backLinkQueryParams) {
      const fullUrl = `${this.backLinkPath}?${this.backLinkQueryParams}`;
      this._router.navigateByUrl(fullUrl).then();
    } else {
      this._router.navigate(['/admin']).then();
    }
  }

  onKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.goBack();
    }
  }
}
